import { DbQueries } from "./db-queries";
import { DBSchema } from "./db-schema";

export class DBMigrate {
  constructor() {}

  public createSchema(db: any) {
    db.sqlBatch(
      [
        DBSchema.USER_ROLE,
        DBSchema.TEAM_ROLE,
        DBSchema.ASSESSMENT_TYPE,
        DBSchema.LOOKUP,
        DBSchema.STATIC_DATA,
        DBSchema.ASSESSMENT,
        DBSchema.PATIENT_DATA,
        DBSchema.LEVEL_OF_CARE,
        DbQueries.INSERT_LEVEL_OF_CARE,
        DBSchema.ASSESSMENT_DETAILS,
        DBSchema.ASSESSMENT_TEMPLATE,
        DBSchema.OFFLINE_ACTIONS,
        DBSchema.RULES_TEMPLATE,
        DBSchema.ASSESSMENT_TEMPLATE_CONFIG,
        DBSchema.ASSESSMENT_SECTION_TEMPLATE_CONFIG,
        DBSchema.ASSESSMENT_SECTION_TYPE_ENUM,
        DbQueries.INSERT_ASSESSMENT_SECTION_TYPE_ENUM,
        DBSchema.PERMISSION_DICTIONARY,
        DBSchema.ASSESSMENT_VALIDATION,
        DBSchema.TEMPLATE_REPLACEMENT_DATA,
      ],
      () => {
        console.log("Populated database OK");
      },
      (error) => {
        console.log("SQL batch ERROR: " + error.message);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/offline-database/db-migration.ts